import React from 'react';
import { useSessionStore } from '../../stores/';

import { Tooltip, Menu, MenuItem, Button } from '@mui/material';
import { UserSearch } from 'lucide-react';

function NavbarCustomerDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);
  const customers = useSessionStore.use.availableCustomers();
  const currentCustomer = useSessionStore.use.currentCustomer();
  const refreshContext = useSessionStore.use.refreshContext();

  const toggleMenu = (event: React.SyntheticEvent) => {
    if (customers.length > 1) {
      setAnchorMenu(event.currentTarget);
    }
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const changeCustomer = async (customerId: string) => {
    closeMenu();
    if (currentCustomer?.id !== customerId) {
      await refreshContext(customerId);
    }
  };

  return (
    <>
      <Tooltip title={customers.length > 1 ? 'Select Customer' : null}>
        <Button
          variant="outlined"
          color="secondary"
          endIcon={customers.length > 1 ? <UserSearch /> : null}
          aria-owns={anchorMenu ? 'menu-customer' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          sx={{ cursor: customers.length > 1 ? 'pointer' : 'default' }}
        >
          {currentCustomer?.displayName}
        </Button>
      </Tooltip>
      <Menu id="menu-customer" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        {customers.map((customer) => (
          <MenuItem key={customer.id} onClick={() => changeCustomer(customer.id)}>
            {customer.displayName}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default NavbarCustomerDropdown;
